import { useState } from 'react'
import { Chip, CircularProgress, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import type { StreamingToolCall } from '../chat/useChatSession.js'
import { formatToolResult } from './formatToolResult.js'

const icon = (status: StreamingToolCall['status']) => {
  if (status === 'running') return <CircularProgress size={14} />
  if (status === 'done') return <CheckCircleIcon fontSize="small" color="success" />
  return <ErrorIcon fontSize="small" color="error" />
}

const label = (call: StreamingToolCall) => {
  if (call.status === 'running') return `Rufe ${call.toolName} auf …`
  if (call.status === 'done') return `${call.toolName} erfolgreich`
  return `${call.toolName} fehlgeschlagen`
}

export const ToolChip = ({ call }: { call: StreamingToolCall }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Chip
        icon={icon(call.status)}
        label={label(call)}
        onClick={() => setOpen(true)}
        variant="outlined"
        size="small"
        sx={{ mr: 1, mb: 1 }}
        color={call.status === 'error' ? 'error' : undefined}
      />
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{call.toolName}</DialogTitle>
        <DialogContent>
          <Typography variant="subtitle2" mt={1}>
            Argumente
          </Typography>
          <Typography
            component="pre"
            variant="body2"
            sx={{ whiteSpace: 'pre-wrap', bgcolor: 'action.hover', p: 1, borderRadius: 1 }}
          >
            {JSON.stringify(call.args, null, 2)}
          </Typography>
          {call.resultPreview !== undefined && (
            <>
              <Typography variant="subtitle2" mt={2}>
                Ergebnis
              </Typography>
              <Typography
                component="pre"
                variant="body2"
                sx={{ whiteSpace: 'pre-wrap', bgcolor: 'action.hover', p: 1, borderRadius: 1 }}
              >
                {formatToolResult(call.resultPreview)}
              </Typography>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  )
}
